// Internationalization composable

"use strict";

import { computed, type ComputedRef } from "vue";
import { activeLocaleRef, translate, updateActiveLocale } from "@/i18n";

/**
 * Composable for translations and locale state.
 * @returns `t` translator, reactive `locale`, and `updateLocale` to sync the active locale ref
 */
export function useI18n() {
    return {
        t: translate,
        locale: activeLocaleRef,
        updateLocale: updateActiveLocale,
    };
}

/**
 * Returns a computed translation for reactive use in script setup.
 * Use this instead of `const text = t("key")`, which only evaluates once.
 * @param key Translation key
 */
export function useTranslation(key: string): ComputedRef<string> {
    return computed(() => translate(key));
}
